
export const countries = [
  { value: "852", label: "+852" },
  { value: "853", label: "+853" },
  { value: "86", label: "+86" },
];

export const dummyData =[
  {
    "StatusCode": 200,
    "Info": "Success",
    "Data": [
        {
            "id": 3,
            "title": "Samsung Galaxy Book3 系列 x Microsoft",
            "target": null,
            "html": null,
            "tutor_name": null,
            "remark": null,
            "status": 0,
            "sort_order": 0,
            "img_1": null,
            "img_2": null,
            "img_3": null,
            "workshop_location": [
                {
                    "address": "() ",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 10,
                                    "time_slot": "15:00 - 16:00",
                                    "quota": 10
                                },
                                {
                                    "workshop_detail_id": 11,
                                    "time_slot": "14:30 - 15:00",
                                    "quota": 10
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(三星專門店 - 將軍澳) 將軍澳唐賢街9號PopCorn 1 地下 G38-39號舖",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 35,
                                    "time_slot": "14:00 - 15:00",
                                    "quota": 10
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": 33,
            "title": "test_003 (with waiting list)",
            "target": null,
            "html": null,
            "tutor_name": null,
            "remark": null,
            "status": 0,
            "sort_order": 0,
            "img_1": null,
            "img_2": null,
            "img_3": null,
            "workshop_location": [
                {
                    "address": "(三星專門店 - 將軍澳) 將軍澳唐賢街9號PopCorn 1 地下 G38-39號舖",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 72,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 5
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(三星專門店 - 尖沙咀) 尖沙咀海港城海洋中心3樓332號舖",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 73,
                                    "time_slot": "13:30 - 15:00",
                                    "quota": 5
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(GoodNotes - 尖沙咀) ",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 75,
                                    "time_slot": "17:30 - 19:00",
                                    "quota": 5
                                },
                                {
                                    "workshop_detail_id": 82,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 5
                                },
                                {
                                    "workshop_detail_id": 83,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 5
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(三星專門店 - 九龍灣) 九龍灣德福廣場一期地下G56-57號舖",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 76,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": 34,
            "title": "test_update timeslot",
            "target": null,
            "html": null,
            "tutor_name": null,
            "remark": null,
            "status": 0,
            "sort_order": 0,
            "img_1": null,
            "img_2": null,
            "img_3": null,
            "workshop_location": [
                {
                    "address": "(觀塘APM -  - Samsung Partnershop) 觀塘創紀之城第5期 APM 5樓 L5 - 3舖",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 77,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 3
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(GoodNotes - 尖沙咀) ",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 78,
                                    "time_slot": "14:00 - 15:00",
                                    "quota": 5
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(三星專門店 - 將軍澳) 將軍澳唐賢街9號PopCorn 1 地下 G38-39號舖",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 79,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 2
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(三星專門店 - 荃灣) 荃灣眾安街68號荃灣千色匯一期地鋪G001b",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 80,
                                    "time_slot": "13:00 - 14:00",
                                    "quota": 2
                                }
                            ]
                        }
                    ]
                },
                {
                    "address": "(YouTube 課堂直播) YouTube 課堂直播",
                    "workshop_date": [
                        {
                            "date": "2026-01-01",
                            "workshop_time": [
                                {
                                    "workshop_detail_id": 81,
                                    "time_slot": "10:00 - 11:00",
                                    "quota": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        },
       
    ]
}
]